/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface ResendVerificationEmailRequest
 */
export interface ResendVerificationEmailRequest {
  /**
   * Электронная почта
   * @type {string}
   * @memberof ResendVerificationEmailRequest
   */
  email: string
}

/**
 * Check if a given object implements the ResendVerificationEmailRequest interface.
 */
export function instanceOfResendVerificationEmailRequest(
  value: object
): value is ResendVerificationEmailRequest {
  if (!('email' in value) || value['email'] === undefined) return false
  return true
}

export function ResendVerificationEmailRequestFromJSON(
  json: any
): ResendVerificationEmailRequest {
  return ResendVerificationEmailRequestFromJSONTyped(json, false)
}

export function ResendVerificationEmailRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ResendVerificationEmailRequest {
  if (json == null) {
    return json
  }
  return {
    email: json['email'],
  }
}

export function ResendVerificationEmailRequestToJSON(
  value?: ResendVerificationEmailRequest | null
): any {
  if (value == null) {
    return value
  }
  return {
    email: value['email'],
  }
}
